/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersdisabledtoast2Inputs */

const en_membersdisabledtoast2 = /** @type {(inputs: Membersdisabledtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memberships are off`)
};

const de_membersdisabledtoast2 = /** @type {(inputs: Membersdisabledtoast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft ist aus`)
};

/**
* | output |
* | --- |
* | "Memberships are off" |
*
* @param {Membersdisabledtoast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersdisabledtoast2 = /** @type {((inputs?: Membersdisabledtoast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersdisabledtoast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersdisabledtoast2(inputs)
	return de_membersdisabledtoast2(inputs)
});
export { membersdisabledtoast2 as "membersDisabledToast" }